import React from "react";
import "./Navbar.css";

function Navbar() {
	function handleClick() {
		const burger = document.querySelector(".burger");
		const nav = document.querySelector(".nav-links");
		const navLinks = document.querySelectorAll(".nav-links li");
		// Toggle Nav
		nav.classList.toggle("nav-active");
		// Animate Links
		navLinks.forEach((link, index) => {
			if (link.style.animation) {
				link.style.animation = "";
			} else {
				link.style.animation = `navLinkFade 0.5s ease forwards ${
					index / 7 + 0.3
				}s`;
			}
		});
		burger.classList.toggle("toggle");
	}

	// Tapping a link on mobile navigates to the section but leaves the open menu
	// covering it, so close it on the way out. Closes rather than toggles: on
	// desktop the menu is never "nav-active" and this must stay a no-op there.
	function closeMenu() {
		const nav = document.querySelector(".nav-links");
		if (!nav.classList.contains("nav-active")) return;

		nav.classList.remove("nav-active");
		document.querySelectorAll(".nav-links li").forEach((link) => {
			link.style.animation = "";
		});
		document.querySelector(".burger").classList.remove("toggle");
	}

	return (
		<section id="navbar">
			<nav className="navbar">
				<div>
					<span className="logo">Rafiziomed</span>
				</div>
				<ul className="nav-links">
					<li>
						<a href="#about" onClick={closeMenu}>
							Despre
						</a>
					</li>
					<li>
						<a href="#doctors" onClick={closeMenu}>
							Echipa
						</a>
					</li>
					<li>
						<a href="#gallery" onClick={closeMenu}>
							Galerie
						</a>
					</li>
					<li>
						<a href="#pricing" onClick={closeMenu}>
							Preturi
						</a>
					</li>
					<li>
						<a href="#contact" onClick={closeMenu}>
							Contact
						</a>
					</li>
				</ul>
				<div className="burger-wraper">
					<div className="burger" onClick={handleClick}>
						<div className="line1"></div>
						<div className="line2"></div>
						<div className="line3"></div>
					</div>
				</div>
			</nav>
		</section>
	);
}

export default Navbar;
